"use client";

import { Button } from "@ui/components/core/Button";
import ChevronLeft24 from "@ui/icons/24x24/chevron-left-24.svg";
import { cn } from "@ui/lib/utils";
import { useTranslations } from "next-intl";

interface BackButtonProps {
  className?: string;
  onClick: () => void;
}

export function BackButton({ onClick, className }: BackButtonProps) {
  const t = useTranslations("ClientKeys.VideoToMusic");

  return (
    <Button
      aria-label={t("back")}
      className={cn(
        "absolute left-16 top-16 z-10 h-40 w-40 rounded-full p-0",
        "border-gray-200 border bg-default shadow-sm",
        "transition-all duration-200 hover:shadow-md",
        className,
      )}
      onClick={onClick}
      variant='ghost'
    >
      <ChevronLeft24 />
    </Button>
  );
}
